<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        List W/H Tax Payable (Pemotongan PPh Vendor)
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="printJv()">
            <i class="fa fa-print"></i> Print JV
          </button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i> Export
          </button>
          <b-button variant="primary mr-1" @click="exportConfirm = true"
            >CSV e-Faktur</b-button
          >
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <b-row>
        <b-col lg="4">
          <b-form-group label-cols="3" label="Tanggal Transaksi">
            <b-row>
              <b-col class="pr-1" cols="6"
                ><b-form-input
                  v-model="filter.tgl1"
                  type="date"
                  placeholder="from date"
                  @change="updateTgl2"
                ></b-form-input
              ></b-col>
              <b-col class="pl-1" cols="6"
                ><b-form-input
                  v-model="filter.tgl2"
                  type="date"
                  placeholder="until date"
                ></b-form-input
              ></b-col>
            </b-row>
          </b-form-group>
        </b-col>
        <b-col>
          <button class="btn btn-primary mr-1" @click="process()">
            <i class="fa fa-play"></i>
            Process
          </button>
        </b-col>
      </b-row>
      <b-card no-body v-if="filterShow == 'Hide'" class="mb-0">
        <template v-slot:header>
          <b-row class="mb-2">
            <b-col lg="3">
              <b-input-group size="sm" class="mt-1">
                <b-input-group-prepend>
                  <span class="pt-1 mr-1">FILTER</span>
                </b-input-group-prepend>
                <b-form-input
                  v-model="filterPph"
                  type="search"
                  id="filterInput"
                  placeholder="Type to Search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filterPph" @click="clearFilterPph"
                    >Clear</b-button
                  >
                </b-input-group-append>
              </b-input-group>
              <b-form-checkbox
                v-model="filterShow"
                value="Hide"
                unchecked-value="Show"
                switch
              >
                <b>{{ filterShow }}</b> Filter
              </b-form-checkbox>
            </b-col>
            <b-col lg="9">
              <b-form-group
                label="FILTER ON :"
                label-cols-sm="1"
                description="Leave all unchecked to filter on all data"
                class="mb-0"
              >
                <b-form-checkbox-group v-model="filterOnPph" class="mt-1">
                  <b-form-checkbox value="namawp"
                    >Nama PKP penjual BKP/JKP</b-form-checkbox
                  >
                  <b-form-checkbox value="npwp">N P W P</b-form-checkbox>
                  <b-form-checkbox value="nofaktur">No Faktur</b-form-checkbox>
                  <b-form-checkbox value="invoice">No. Invoice</b-form-checkbox>
                  <b-form-checkbox value="uraian">Description</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
        </template>
      </b-card>

      <b-table
        class="mb-0"
        ref="tableLcy"
        sticky-header="600px"
        outlined
        responsive
        striped
        hover
        style="font-size: smaller"
        :items="dataPph"
        :fields="tblPph.fields"
        :current-page="tblPph.page"
        :per-page="tblPph.limit"
        :sort-by.sync="tblPph.sortBy"
        :sort-desc.sync="tblPph.sortDesc"
        :filter="filterPph"
        :filterIncludedFields="filterOnPph"
        @filtered="onFilteredPph"
        @row-clicked="confirmAction"
      >
        <template v-slot:cell(action)="data">
          <div class="text-center">
            <a href="javascript:void(0)" @click="edit(data.item)">
              <i class="fa fa-pencil"></i>
            </a>
          </div>
        </template>
        <template v-slot:cell(tglfaktur)="data">
          <span v-if="data.item.tglfaktur">{{
            data.item.tglfaktur | moment("DD-MMM-YYYY")
          }}</span>
        </template>
        <template v-slot:cell(nilaipph)="data">
          {{ data.item.nilaipph | numFormat }}
        </template>
        <template v-slot:cell(kurspph)="data">
          {{ data.item.kurspph | numFormat }}
        </template>
        <template v-slot:cell(pphlcy)="data">
          {{ data.item.pphlcy | numFormat }}
        </template>
        <template v-slot:cell(jenisphs)="data">
          {{ data.item.jenisphs }}
          <span v-if="data.item.penghasilan">
            | {{ data.item.penghasilan }}</span
          >
        </template>
        <template v-slot:cell(invdate)="data">
          <span v-if="data.item.fakturppn_tgl">{{
            data.item.fakturppn_tgl | moment("DD-MMM-YYYY")
          }}</span>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div style="font-weight: bolder" :key="totalLcy">
            Total : {{ uanguser }} {{ totalLcy | numFormat }}
          </div>
        </b-col>
        <b-col cols="8">
          <b-row>
            <b-col cols="6" style="text-align: center">
              <div>
                Showing {{ (tblPph.page - 1) * tblPph.limit + 1 }} to
                <span v-if="tblPph.page * tblPph.limit > tblPph.total">{{
                  tblPph.total
                }}</span>
                <span v-else>{{ tblPph.page * tblPph.limit }}</span> of
                {{ tblPph.total }} entries,
                <span class="ml-3 mr-1">limit per page :</span>
                <select v-model="tblPph.limit" style="width: 60px" class="ml-2">
                  <option>10</option>
                  <option>15</option>
                  <option>20</option>
                  <option>25</option>
                  <option>30</option>
                  <option>40</option>
                  <option>50</option>
                  <option>60</option>
                  <option>70</option>
                  <option>80</option>
                  <option>90</option>
                </select>
              </div>
              <b-form-checkbox
                v-model="filterShow"
                value="Hide"
                unchecked-value="Show"
                switch
              >
                <b> {{ filterShow }}</b> Filter
              </b-form-checkbox>
            </b-col>
            <b-col cols="6">
              <b-pagination
                class="ml-1"
                align="right"
                :total-rows="tblPph.total"
                :per-page="tblPph.limit"
                v-model="tblPph.page"
              ></b-pagination>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
    <b-modal
      v-model="showForm"
      header-bg-variant="primary"
      title="Edit - PPh dipotong"
      size="lg"
      :centered="true"
      @ok="handleOk"
      ok-title="Save"
    >
      <b-form @submit.stop.prevent="save">
        <b-input-group>
          <b-input-group-prepend
            ><label>Supplier/Vendor</label></b-input-group-prepend
          >
          <b-form-input readonly v-model="model.vendorinfo"></b-form-input>
          <b-input-group-append>
            <b-btn
              variant="primary"
              text="Button"
              @click="lkuVendorShow = true"
            >
              <i class="fa fa-search"></i>
            </b-btn>
          </b-input-group-append>
        </b-input-group>
        <b-row>
          <b-col lg="6">
            <b-input-group>
              <b-input-group-prepend
                ><label>N P W P</label></b-input-group-prepend
              >
              <b-form-input
                v-model="model.npwp"
                :state="!$v.model.npwp.$error"
              ></b-form-input>
            </b-input-group>
          </b-col>
          <b-col lg="6" v-if="model.vendor_id">
            <b-input-group>
              <b-input-group-prepend class="d-md-inline d-lg-none"
                ><label class="text-right"
                  >&nbsp;-</label
                ></b-input-group-prepend
              >
              <b-form-radio-group
                class="mt-2"
                v-model="model.IsIndividu"
                name="radioIndividu"
              >
                <b-form-radio value="0">Perusahaan</b-form-radio>
                <b-form-radio value="1">Individu/Personal</b-form-radio>
              </b-form-radio-group>
            </b-input-group>
          </b-col>
          <b-col lg="6" v-else>
            <b-input-group>
              <b-form-checkbox
                class="ml-2 mt-2"
                v-model="model.vendor_new"
                value="1"
                unchecked-value="0"
              >
                Tambahkan sbg Data Vendor Baru
              </b-form-checkbox>
            </b-input-group>
          </b-col>
        </b-row>

        <b-input-group>
          <b-input-group-prepend><label>Nama WP</label></b-input-group-prepend>
          <b-form-input
            v-model="model.namawp"
            :state="!$v.model.namawp.$error"
          ></b-form-input>
        </b-input-group>
        <b-input-group>
          <b-input-group-prepend
            ><label>Alamat WP</label></b-input-group-prepend
          >
          <b-form-input
            v-model="model.alamatwp"
            :state="!$v.model.alamatwp.$error"
          ></b-form-input>
        </b-input-group>
        <b-row>
          <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend
                ><label>Jenis WP</label></b-input-group-prepend
              >
              <b-form-select
                v-model="model.taxbusgrp"
                :plain="true"
                :options="taxBussinesGroups"
              ></b-form-select>
            </b-input-group>
          </b-col>
          <b-col lg="5">
            <b-input-group>
              <b-input-group-prepend class="d-md-inline d-lg-none"
                ><label class="text-right"
                  >&nbsp;-</label
                ></b-input-group-prepend
              >
              <b-form-radio-group
                class="mt-2"
                v-model="model.asing"
                name="radioAsing"
              >
                <b-form-radio value="0">Lokal/Dlm Negeri</b-form-radio>
                <b-form-radio value="1">Asing/Luar Negeri</b-form-radio>
              </b-form-radio-group>
            </b-input-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="6">
            <b-input-group>
              <b-input-group-prepend
                ><label>Nomor SKB/SKD</label></b-input-group-prepend
              >
              <b-form-input
                v-model="model.skb_no"
                placeholder="SKB"
              ></b-form-input>
              <b-form-input
                v-model="model.skd_no"
                placeholder="SKD"
                class="ml-1"
              ></b-form-input>
            </b-input-group>
          </b-col>
          <b-col lg="6">
            <b-input-group>
              <b-input-group-prepend
                ><span class="p-2">DTP</span></b-input-group-prepend
              >
              <b-form-input
                v-model="model.dtp_no"
                placeholder="No. Aturan"
              ></b-form-input>
              <b-form-input
                v-model="model.dtp_ntpn"
                placeholder="NTPN"
                class="ml-1"
              ></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend
                ><label>Invoice Number</label></b-input-group-prepend
              >
              <b-form-input
                v-model="model.invoice"
                :state="!$v.model.invoice.$error"
              ></b-form-input>
            </b-input-group>
          </b-col>
          <b-col lg="5">
            <b-input-group>
              <b-input-group-prepend
                ><label style="width: 100px"
                  >Invoice Date</label
                ></b-input-group-prepend
              >
              <b-form-input
                v-model="model.invdate"
                type="date"
                :state="!$v.model.invdate.$error"
              ></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend
                ><label>Faktur PPN</label></b-input-group-prepend
              >
              <b-form-input v-model="model.fakturppn"></b-form-input>
            </b-input-group>
          </b-col>
          <b-col lg="5">
            <b-input-group>
              <b-input-group-prepend
                ><label style="width: 100px"
                  >Tgl. Faktur</label
                ></b-input-group-prepend
              >
              <b-form-input
                v-model="model.fakturppn_tgl"
                type="date"
              ></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>

        <b-input-group>
          <b-input-group-prepend
            ><label>Pasal PPh</label></b-input-group-prepend
          >
          <b-form-select
            v-model="model.pasalpph"
            :plain="true"
            :options="lookupPPH"
            :state="!$v.model.pasalpph.$error"
          ></b-form-select>
          <b-input-group-prepend
            ><span class="input-group-text" style="width: 70px"
              >Tarif</span
            ></b-input-group-prepend
          >
          <b-form-input
            v-model="model.tarif"
            type="number"
            :state="!$v.model.tarif.$error"
          ></b-form-input>
          <b-input-group-append
            ><span class="input-group-text" style="width: 70px"
              >%</span
            ></b-input-group-append
          >
        </b-input-group>
        <b-input-group>
          <b-input-group-prepend
            ><label>Kode Objek</label></b-input-group-prepend
          >
          <b-form-input
            readonly
            v-model="model.penghasilaninfo"
            :state="!$v.model.jenisphs.$error"
          ></b-form-input>
          <b-input-group-append>
            <b-btn text="Button" @click="lkuObjekpphShow = true">
              <i class="fa fa-search"></i>
            </b-btn>
          </b-input-group-append>
        </b-input-group>

        <b-row>
          <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend
                ><label>Nilai DPP</label></b-input-group-prepend
              >
              <b-input-group-prepend
                ><span class="input-group-text" style="width: 60px">{{
                  model.matauang
                }}</span></b-input-group-prepend
              >
              <my-number
                class="form-control text-right"
                v-model="model.nilaidpp"
                :precision="2"
                :state="!$v.model.nilaidpp.$error"
              ></my-number>
            </b-input-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend
                ><label>Nilai PPh</label></b-input-group-prepend
              >
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 100px">{{
                  model.matauang
                }}</span>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.nilaipph"
                :precision="2"
                :state="!$v.model.nilaidpp.$error"
              ></my-number>
            </b-input-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend
                ><label>Kurs Pajak</label></b-input-group-prepend
              >
              <b-input-group-prepend
                ><span class="input-group-text" style="width: 60px">{{
                  model.matauang
                }}</span></b-input-group-prepend
              >
              <b-input-group-prepend
                ><span class="pl-2 pt-2 pr-2">to</span></b-input-group-prepend
              >
              <b-input-group-prepend
                ><span class="input-group-text pl-3" style="width: 60px">{{
                  uanguser
                }}</span></b-input-group-prepend
              >
              <my-number
                class="form-control text-right"
                v-model="model.kurspph"
                :precision="2"
                :state="!$v.model.kurspph.$error"
              ></my-number>
            </b-input-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend
                ><label>Nilai PPh (LCY)</label></b-input-group-prepend
              >
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 100px">{{
                  uanguser
                }}</span>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.pphlcy"
                :precision="2"
                disabled
              ></my-number>
            </b-input-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend
                ><label>No. Bukti Potong</label></b-input-group-prepend
              >
              <b-form-input
                v-model="model.nofaktur"
                :state="!$v.model.nofaktur.$error"
              ></b-form-input>
            </b-input-group>
          </b-col>
          <b-col lg="5">
            <b-input-group>
              <b-input-group-prepend
                ><label>Tgl. Bukti Potong</label></b-input-group-prepend
              >
              <b-form-input
                v-model="model.tglfaktur2"
                type="date"
                :state="!$v.model.tglfaktur2.$error"
              ></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
    <b-modal
      v-model="exportConfirm"
      title="Export Data Choices"
      @ok="exportcsv"
    >
      <h5>PPh Account</h5>
      <b-form-checkbox-group
        v-model="modelExport.account"
        :options="lookupPPH"
      ></b-form-checkbox-group>
    </b-modal>

    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
    <b-modal
      v-model="showReport"
      size="xl"
      scrollable
      title="Preview as PDF"
      ok-only
    >
      <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal
      v-model="lkuObjekpphShow"
      size="lg"
      :hide-footer="true"
      title="Daftar Kode Bukti Potong(Objek Pajak)"
      :centered="true"
    >
      <lku-objekpph @click="onSelectLkuObjekpph"></lku-objekpph>
    </b-modal>

    <b-modal
      v-model="lkuVendorShow"
      size="lg"
      :hide-footer="true"
      title="List of Vendor"
      :centered="true"
    >
      <lku-vendor @click="onSelectLkuVendor"></lku-vendor>
    </b-modal>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import myNumber from "../../components/my-number";
import pphpayable from "../../apis/pphpayable";
import toastr from "mini-toastr";
import moment from "moment";
import { validationMixin } from "vuelidate";
import { required, minValue } from "vuelidate/lib/validators";
import lkuObjekpph from "../lookup/lkuObjekpph";
import lkuVendor from "../lookup/lkuVendor";

toastr.init();

export default {
  components: { myNumber, lkuObjekpph, lkuVendor, Loading },
  mixins: [validationMixin],
  validations: {
    filter: {
      tgl1: { required },
      tgl2: { required },
    },
    modelExport: {
      account: { required },
      tgl1: { required },
      tgl2: { required },
    },
    model: {
      namawp: { required },
      npwp: { required },
      alamatwp: { required },
      invoice: { required },
      invdate: { required },
      matauang: { required },
      nofaktur: { required },
      tglfaktur2: { required },
      nilaidpp: { required, minValue: minValue(1) },
      nilaipph: { required, minValue: minValue(1) },
      kurspph: { required, minValue: minValue(0.00000001) },
      jenisphs: { required },
      pasalpph: { required },
      tarif: { required, minValue: minValue(0.00000001) },
    },
  },
  data() {
    return {
      filter: { tgl1: "", tgl2: "" },
      modelExport: { account: "", tgl1: "", tgl2: "" },
      isLoading: false,
      showReport: false,
      exportConfirm: false,
      showForm: false,
      reportUrl: null,
      tahun: moment(this.$store.state.user.tglaktif).format("YYYY"),
      uanguser: this.$store.state.user.matauang,
      model: {
        namawp: "",
        npwp: "",
        alamatwp: "",
        invoice: "",
        invdate: "",
        matauang: "",
        nofaktur: "",
        tglfaktur2: "",
        nilaidpp: 0,
        nilaipph: 0,
        kurspph: 1,
        jenisphs: "",
        pasalpph: "-",
        tarif: 0,
        vendor_new: 0,
      },
      totalLcy: 0,
      selected: {},
      dataPph: [],
      taxBussinesGroups: [],
      lookupPPH: [],
      jenisPenghasilan: [],
      lkuObjekpphShow: false,
      lkuVendorShow: false,
      filterShow: "Show",
      filterPph: null,
      filterOnPph: [],
      tblPph: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields: [
          {
            key: "action",
            label: "",
            thStyle: "width:25px",
            thClass: "text-center",
          },
          {
            key: "namawp",
            label: "Nama PKP penjual BKP/penjual JKP",
            sortable: true,
            filterable: true,
          },
          {
            key: "npwp",
            label: "N P W P",
            sortable: true,
            filterable: true,
          },

          {
            key: "pasalpph",
            label: "Pasal PPh",
            sortable: true,
          },
          {
            key: "tarif",
            label: "Tarif",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "nofaktur",
            label: "No. Bukti Potong",
            sortable: true,
          },
          {
            key: "jenisphs",
            label: "Jenis Penghasilan",
            sortable: true,
          },
          {
            key: "nilaiDpp",
            label: "Objek Pemotongan",
            sortable: true,
          },
          {
            key: "pphlcy",
            label: "Pph Dipotong",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "tglfaktur",
            label: "Tgl Potong",
            sortable: true,
          },

          {
            key: "invoice",
            label: "Nomor Invoice",
            sortable: true,
          },
          {
            key: "fakturppn",
            label: "faktur PPN",
            sortable: true,
          },
          {
            key: "fakturppn_tgl",
            label: "Tgl PPN",
            sortable: true,
          },
          {
            key: "uraian",
            label: "Description",
            sortable: true,
          },
          {
            key: "matauang",
            label: "$,¥",
            sortable: true,
          },
          {
            key: "nilaipph",
            label: "Nilai Asli",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "kurspph",
            label: "Kurs",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "nomorbk",
            label: "Nomor BK/KK",
            sortable: true,
            tdClass: "text-center",
          },
        ],
      },
    };
  },
  computed: {
    dimension() {
      return this.$store.state.dimension;
    },
    invalidFilter() {
      this.$v.filter.$touch();
      return this.$v.filter.$invalid;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
  watch: {
    "model.pasalpph": function (newval) {
      const item = this.lookupPPH.find((p) => p.value == newval);
      console.log("pasalpph: ", item);
      if (item) {
        this.model.tarif = item.pph;
      }
      setTimeout(() => {
        this.calcTaxes();
      }, 100);
    },
    "model.tarif": function (newval) {
      setTimeout(() => {
        this.calcTaxes();
      }, 100);
    },
    "model.nilaidpp": function (newval) {
      setTimeout(() => {
        this.calcTaxes();
      }, 100);
    },
    "model.kurspph": function (newval) {
      setTimeout(() => {
        this.calcTaxes();
      }, 100);
    },
  },
  created: async function () {
    const [a, b, c] = await Promise.all([
      pphpayable.taxgroup(),
      pphpayable.pasalpph(),
      pphpayable.jenispenghasilan(),
    ]);
    this.taxBussinesGroups = a;
    this.lookupPPH = b;
    this.jenisPenghasilan = c;

    //  this.tahun=moment(user.tglaktif).format('YYYY');
    if (this.$route.params.tgl1 && this.$route.params.tgl2) {
      // this.filter.kodeaw = this.$route.params.kodeaw;
      // this.filter.kodeak = this.$route.params.kodeak || this.filter.kodeaw;
      // this.filter.kodeawinfo = this.$route.params.kodeaw;
      // this.filter.kodeakinfo = this.$route.params.kodeak || this.filter.kodeaw;
      this.filter.tgl1 = this.$route.params.tgl1;
      this.filter.tgl2 = this.$route.params.tgl2;
      this.process();
    } else {
      var tgl2 = moment(this.$store.state.user.tglaktif, "YYYY-MM-DD")
        .add(1, "M")
        .subtract(1, "day");
      this.filter.tgl1 = `${tgl2.format("YYYY-MM")}-01`;
      this.filter.tgl2 = tgl2.format("YYYY-MM-DD");
      this.tahun = tgl2.format("YYYY");
    }
  },
  methods: {
    // updateTgl1: function() {
    //     var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
    //     if (!this.filter.tgl1){
    //         this.filter.tgl1=`${tgl2.format('YYYY-MM')}-01`;
    //         this.tahun=tgl2.format('YYYY');
    //         this.$forceUpdate();
    //     } else {
    //         var tgl1 = moment(this.filter.tgl1, 'YYYY-MM-DD');
    //         if (tgl1.format('YYYY') !== tgl2.format('YYYY')){
    //             this.filter.tgl1=`${tgl2.format('YYYY')}-01-01`;
    //             this.tahun=tgl2.format('YYYY');
    //             this.$forceUpdate();
    //         }
    //     }
    // },
    updateTgl2: function () {
      var tgl1 = moment(this.filter.tgl1, "YYYY-MM-DD");
      if (!this.filter.tgl2) {
        this.filter.tgl2 = `${tgl1.format("YYYY")}-12-31`;
        this.tahun = tgl1.format("YYYY");
        this.$forceUpdate();
      } else {
        var tgl2 = moment(this.filter.tgl2, "YYYY-MM-DD");
        if (tgl1.format("YYYY") !== tgl2.format("YYYY")) {
          this.filter.tgl2 = `${tgl1.format("YYYY")}-12-31`;
          this.tahun = tgl1.format("YYYY");
          this.$forceUpdate();
        }
      }
    },
    onSelectLkuVendor: function (_selected) {
      this.lkuVendorShow = false;
      this.model.vendorinfo =
        _selected.vendor_code.trim() + " | " + _selected.vendor_name.trim();
      this.model.vendor_id = _selected.vendor_id;
      this.model.npwp = _selected.npwp;
      this.model.namawp = _selected.npwp_name;
      this.model.alamatwp = _selected.npwp_address1;
    },
    onSelectLkuObjekpph: function (_selected) {
      this.lkuObjekpphShow = false;
      this.model.penghasilaninfo = _selected.penghasilan;
      this.model.jenisphs = _selected.jenisphs;
    },
    onFilteredPph: function (filteredItems) {
      this.tblPph.total = filteredItems.length;
      this.tblPph.page = 1;
    },
    clearFilterPph() {
      this.filterOnPph = [];
      this.filterPph = "";
    },

    process: async function () {
      if (this.invalidFilter) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          // Test Hak akses SUDAH BENAR,  jika api controller didaftar di sys_api
          const result = await pphpayable.list(this.filter);
          this.dataPph = result[0];
          this.totalLcy = 0;
          this.dataPph.forEach((ap) => {
            this.totalLcy += ap.pphlcy;
          });
          this.tblPph.total = result[0].length;
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    edit: function (record) {
      if (this.row) delete this.row.isSelected;
      this.row = record;
      record.isSelected = 1;
      this.model = this.model || {};
      if (this.model.tablekey != record.tablekey) {
        this.model.tablekey = "";
        this.model.customer_id = "";
        this.model.vendorinfo = "";
        this.model.namawp = "";
        this.model.npwp = "";
        this.model.alamatwp = "";
        this.model.invoice = "";
        this.model.invdate = "";
        this.model.matauang = "";
        this.model.nofaktur = "";
        this.model.jenisphs = "";
        this.model.tglfaktur = "";
        this.model.tglfaktur2 = "";
        this.model.nilaidpp = 0;
        this.model.kurspph = 1;
        this.model.nilaipph = 0;
        this.model.pphlcy = 0;
        this.model.wpluarnegri = 0;

        for (var key in record) {
          this.model[key] = record[key];
        }
        this.model.invdate = record.invdate
          ? moment(record.invdate).format("YYYY-MM-DD")
          : "";
        this.model.fakturppn_tgl = record.fakturppn_tgl
          ? moment(record.fakturppn_tgl).format("YYYY-MM-DD")
          : "";
        this.model.tglfaktur = record.tglfaktur
          ? moment(record.tglfaktur).format("YYYY-MM-DD")
          : "";
        this.model.tglfaktur2 = moment(record.tglfaktur).format("YYYY-MM-DD");
        this.model.vendor_new = 0;
        this.model.penghasilaninfo = `${this.model.jenisphs} | ${this.model.penghasilan}`;
        this.model.pphlcyasli = this.model.pphlcy;
        this.model.nilaipphasli = this.model.nilaipph;
        this.model.wpluarnegri = record.wpluarnegri || 0;
      }
      this.showForm = true;
    },
    confirmAction: function (record) {
      if (record.isSelected) {
        toastr.info("Loading Form - Edit ");
        //   this.model = this.model || {};
        if (this.model.tablekey != record.tablekey) {
          for (var key in this.model) {
            this.model[key] = "";
          }
          for (var key in record) {
            this.model[key] = record[key];
          }
          this.model.invdate = moment(record.invdate).format("YYYY-MM-DD");
          this.model.tglfaktur2 = moment(record.tglfaktur).format("YYYY-MM-DD");
          this.model.vendor_new = 0;
          this.model.penghasilaninfo = `${this.model.jenisphs} | ${this.model.penghasilan}`;
          this.model.pphlcyasli = this.model.pphlcy;
          this.model.nilaipphasli = this.model.nilaipph;
        }
        this.showForm = true;
      } else {
        if (this.row) delete this.row.isSelected;
        this.row = record;
        record.isSelected = 1;
        this.$forceUpdate();
      }
    },

    print: async function () {
      if (this.invalidFilter) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          this.reportUrl = null; this.showReport = true;
          this.reportUrl = await pphpayable.rptglprint(this.filter);
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    exportcsv: async function () {
      if (this.invalidFilter) {
        console.log("selected obj : ", this.filter);
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          const response = await pphpayable.exportcsv(this.filter);
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    exportxls: async function () {
      if (this.invalidFilter) {
        console.log("selected obj : ", this.filter);
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          const response = await pphpayable.exportxls(this.filter);
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    calcTaxes: function () {
      // if (!this.model.nilaipphasli) {
      //   this.model.nilaipph = this.model.nilaidpp * (this.model.tarif / 100);
      // }
      // if (!this.model.pphlcyasli) {
      //   this.model.pphlcy = this.model.nilaipph * this.model.kurspph;
      // }
      if (this.model.tarif) {
        if (!this.model.nilaidpp || this.model.nilaidpp == 0) {
          this.model.nilaidpp = this.model.nilaipph * (100 / this.model.tarif);
        } else {
          this.model.nilaipph = this.model.nilaidpp * (this.model.tarif / 100);
        }
      }
      this.model.pphlcy = this.model.nilaipph * this.model.kurspph;
    },

    handleOk: function (evt) {
      evt.preventDefault();
      if (this.invalidModel) {
        const invalidobj = {};
        for (var key in this.$v.model) {
          if (this.$v.model[key].$anyError) {
            if (this.$v.model[key].$anyError == true)
              invalidobj[key] = this.$v.model[key];
          }
        }
        console.log("validation model: ", this.model);
        console.log("validation field: ", invalidobj);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        this.isLoading = false;
      } else {
        this.save();
      }
    },
    save: async function () {
      if (this.invalidModel) {
        const invalidobj = {};
        for (var key in this.$v.model) {
          if (this.$v.model[key].$anyError) {
            if (this.$v.model[key].$anyError == true)
              invalidobj[key] = this.$v.model[key];
          }
        }
        console.log("validation model: ", this.model);
        console.log("validation field: ", invalidobj);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        this.isLoading = false;
      } else {
        this.isLoading = true;
        try {
          await pphpayable.save(this.model);
          this.isLoading = false;
          for (var key in this.model) {
            this.row[key] = this.model[key];
          }
          this.row.tglfaktur = moment(this.model.tglfaktur2, "YYYY-MM-DD");
          this.showForm = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },

    printJv: async function () {
      if (this.row) {
        this.isLoading = true;
        try {
          this.reportUrl = null; this.showReport = true;
          this.reportUrl = await pphpayable.printjv(this.row);
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      } else {
        toastr.warn("Please select a row that want to be Print!");
      }
    },
    close() {
      router.push("home");
    },
  },
};
</script>
